/**
 * AppUpdateNotice — the platform console's «there is a new version» popup.
 *
 * The behaviour lives in `@obrava/ui` (UpdateAvailableNotice) and the recognition of a new
 * build in `@obrava/shared` (domain/appUpdate), shared with the backoffice. This thin
 * wrapper only supplies what is specific to the app: the translated copy and the Vite
 * environment (`PROD`, `BASE_URL`), which the shared package cannot read.
 *
 * Mounted once, above the router (main.tsx), so it also reaches the sign-in screen.
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { UpdateAvailableNotice } from '@obrava/ui';

export function AppUpdateNotice(): React.ReactElement {
  const { t } = useTranslation();
  return (
    <UpdateAvailableNotice
      enabled={import.meta.env.PROD}
      indexUrl={`${import.meta.env.BASE_URL}index.html`}
      title={t('common:updateAvailableTitle')}
      body={t('common:updateAvailableBody')}
      actionLabel={t('common:updateAction')}
      closeLabel={t('common:close')}
    />
  );
}
